import { toast } from 'react-toastify';
import Transition from './transition';

const common = (status) => {
  switch (status) {
    case 400:
      toast.error('入力内容に誤りがあります。入力内容を確認してください。');
      break;
    case 401:
    case 403:
      Transition.goToLogin();
      break;
    case 404:
      break;
    case 409:
      toast.error('対象のデータはすでに変更されています。画面を更新してください。');
      break;
    case 500:
    case 504:
      toast.error('システムエラーが発生しました。しばらくしてから操作してください。');
      break;
    default:
      // toast.error('システムエラーが発生しました。しばらくしてから操作してください。');
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { common };
